<template lang="pug">
the-header
first-layer
img.live__logo.mobile(src='./static/KV_v8_neoconf.svg' style='margin: 0px auto 24px; display: flex; position: relative; z-index: 10')
live
event
zoom
smart
activity
the-footer
login
preload
</template>

<script>
import theHeader from './components/theHeader.vue';
import firstLayer from './components/firstLayer.vue';
import live from './components/live.vue';
import event from './components/event.vue';
import zoom from './components/zoom.vue';
import smart from './components/smart.vue';
import activity from './components/activity.vue';
import theFooter from './components/theFooter.vue';
import preload from './components/preload.vue';
import login from './components/login.vue';

export default {
  name: 'App',
  components: {
    theHeader,
    firstLayer,
    live,
    event,
    zoom,
    smart,
    activity,
    theFooter,
    preload,
    login,
  },
};
</script>

<style lang="sass">
html, body, .app-layout
  overflow-x: hidden
  text-size-adjust: 100%
  margin: 0
  display: flex
  flex-direction: column
  padding-left: env(safe-area-inset-left)
  padding-right: env(safe-area-inset-right)
  padding-top: env(safe-area-inset-top)
  padding-bottom: env(safe-area-inset-bottom)
  -webkit-text-size-adjust: none
  font-family: Arial, Helvetica, sans-serif
  font-style: normal
  font-weight: normal
  background: #000000
.mobile
  @media screen and (min-width: 813px)
    display: none !important
.pc
  @media screen and (max-width: 812px)
    display: none !important
.landscape
  @media screen and (orientation: landscape) and (max-width: 812px)
    display: none !important
button
  &:focus
    outline: none
  cursor: pointer
</style>
